export const formatDetailsInfo = (str: string): string => str.replace(/(_|^)([^_]?)/g, (_, prep, letter) => (prep && ' ') + letter.toUpperCase())
